import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router';
import { MenuTrigger, Button, Popover, Menu, MenuItem } from 'react-aria-components';
import { NavigateRoutes } from '@features/routing/routesObject';



const OrderMenu = () => {
	const { t } = useTranslation('web');

	const navigate = useNavigate();

	return (
		<div className='header-section order-menu-section'>
			<MenuTrigger>

				<Button className='order-menu-button app-main-button disable-selection' autoFocus={false}>
					{t('shared.order')}
				</Button>

				<Popover>
					<Menu onAction={(key: string | number) => navigate(String(key))} autoFocus={false}>
						
						<MenuItem id={NavigateRoutes.order} textValue={t('layouts.header.dogForm')}>
							<Link to={NavigateRoutes.order}>{t('layouts.header.dogForm')}</Link>
						</MenuItem>
						
						<MenuItem id={NavigateRoutes.catOrder} textValue={t('layouts.header.catForm')}>
							<Link to={NavigateRoutes.catOrder}>{t('layouts.header.catForm')}</Link>
						</MenuItem>

					</Menu>
				</Popover>

			</MenuTrigger>
		</div>
	);
}

export default OrderMenu;